import {useEffect} from 'react';
import {history} from 'config/store';
import {toAppRoute} from 'lib/siteLinks';

// Un lien vers le site qui a son écran dans l'application (contenus WordPress affichés,
// liens de notifications, de cartes…) y ouvre cet écran au lieu d'un nouvel onglet.
// data-external sur un lien le laisse s'ouvrir sur le site.
const SiteLinkInterceptor = () => {
  useEffect(() => {
    const onClick = event => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor || anchor.hasAttribute('data-external')) return;

      const route = toAppRoute(anchor.href);
      if (!route) return;
      event.preventDefault();
      history.push(route, anchor.href);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return null;
};

export default SiteLinkInterceptor;
